
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import Hero from "@/components/Hero";
import { useAuth } from "@/contexts/AuthContext";
import { usePurchaseStatus } from "@/hooks/usePurchaseStatus";
import { useEnrollmentHandler } from "@/hooks/useEnrollmentHandler";
import { useSuccessRedirect } from "@/hooks/useSuccessRedirect";
import StatusDisplay from "@/components/checkout/success/StatusDisplay";
import NextStepsSection from "@/components/checkout/success/NextStepsSection";
import ActionButtons from "@/components/checkout/success/ActionButtons";

const CheckoutSuccess = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { user } = useAuth();

  // Get course ID and purchase ID from query string
  const courseId = searchParams.get("courseId");
  const purchaseId = searchParams.get("purchaseId");
  const fallback = searchParams.get("fallback") === "true";
  const status = searchParams.get("status"); // Get status from URL if present

  // Use our custom hooks
  const { 
    purchase, 
    loading, 
    refreshing, 
    autoRefreshActive,
    refreshTimedOut,
    handleRefreshStatus 
  } = usePurchaseStatus(purchaseId);
  
  const { checkedEnrollment } = useEnrollmentHandler(user, courseId, purchase);
  
  // Only redirect if payment was successful
  const redirectEnabled = purchase?.payment_status === "completed" && !status;
  useSuccessRedirect(courseId, redirectEnabled ? purchase : null);

  // If we don't have either courseId or purchaseId, something is wrong
  useEffect(() => {
    if (!courseId && !purchaseId) {
      navigate("/");
    }
  }, [courseId, purchaseId, navigate]);
  
  // Handle if URL contains status=cancelled
  useEffect(() => {
    if (status === "cancelled" && !loading) {
      // No need to show auto-refresh for cancelled payments
      // StatusDisplay component will handle this status
    }
  }, [status, loading]);

  return (
    <div className="fade-in">
      <Hero
        title="Tellimus edukalt esitatud!"
        bgColor="bg-gradient-to-r from-kaija-light to-kaija-sage"
      />

      <section className="section-padding bg-white">
        <div className="container-custom max-w-3xl">
          <StatusDisplay 
            purchase={purchase}
            loading={loading}
            refreshing={refreshing}
            onRefresh={handleRefreshStatus}
            autoRefreshActive={autoRefreshActive}
            courseId={courseId}
          />

          {/* Only show next steps if payment was successful or still processing */}
          {purchase && purchase.payment_status !== "failed" && 
           purchase.payment_status !== "cancelled" && (
            <NextStepsSection />
          )}

          <ActionButtons 
            purchase={purchase}
            courseId={courseId}
          />
        </div>
      </section>
    </div>
  );
};

export default CheckoutSuccess;
